import { useSiteContext } from "../../../context/site/useSiteContext"
import { useJsApiLoader } from "@react-google-maps/api"

const useGoogleMapInstance = (): {
  isLoaded: boolean
  loadError: Error | undefined
} => {
  const {
    apiKeys: { googleMapsApiKey },
  } = useSiteContext()

  return useJsApiLoader({
    googleMapsApiKey,
  })
}

export { useGoogleMapInstance }
